<template>
    <ContentCard theme="darkgreen" icon="assets/images/illu-rocks.svg" class="w-80">
        <template #title>ROCK SOLID SYDNEY - What<br> are you standing on?</template>
        <template #description>
            What did Sydney look like millions of years ago when dinosaurs roamed the Earth? What do rocks and
            fossils tell us about Sydney's past?
        </template>
        <template #buttons>
            <ButtonPill icon="play" class="card__btn me-8"
                        @click.native="$store.commit('SET_LIGHTBOX', '3KaPqf--XrQ')">Watch Now
            </ButtonPill>
            <ButtonPill href="/pdfs/rock-stars.pdf" target="_blank" icon="file" class="card__btn"
                        orange>ACTIVITY
            </ButtonPill>
        </template>
    </ContentCard>
</template>

<script>
import ContentCard from '@/components/ContentCard';
import ButtonPill from '@/components/ButtonPill';
export default {
    components: {ButtonPill, ContentCard}
};
</script>
